'use client';

import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MetaTags } from '../../components/Metatags/Metatags';
import type { RootState } from '../../redux/root-reducer';
import { campaignWorkspaceSelector } from '../../redux/buzzbridge/selectors';
import { CreatorCampaignWorkspaceView } from './CreatorCampaignWorkspaceView';

/**
 * Creator / influencer campaign hub: GET …/creator-workspace.
 * Opened from Buzz Bridge jobs with campaign + participant ids.
 */
export default function CreatorCampaignWorkspacePage() {
    const { campaignId = '', participantId = '' } = useParams<{ campaignId: string; participantId: string }>();
    const currentUserId = useSelector((s: RootState) => s.user.userProfile?._id);
    const workspace = useSelector(campaignWorkspaceSelector);

    const title =
        workspace?.campaign?.title && workspace.brand?.name
            ? `${workspace.campaign.title} · ${workspace.brand.name}`
            : (workspace?.campaign?.title ?? 'Campaign workspace');

    return (
        <MetaTags title={title} description="Campaign workspace">
            <CreatorCampaignWorkspaceView
                campaignId={campaignId}
                participantId={participantId}
                currentUserId={currentUserId}
            />
        </MetaTags>
    );
}
